// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.rating-text {\n    margin-left: 165px !important;\n    font-size: 63px;\n}\n.rating-text-green {\n    color: var(--green-color);\n}\n.rating-text-yellow {\n    color: var(--yellow-color);\n}\n.rating-text-danger {\n    color: var(--danger);\n}\n", ""]);
// Exports
module.exports = exports;
